import { updateCliente, deleteCliente, getClienteById as getCliente } from "@spark/services/clientes";
import { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { notification } from '@spark/ui-components/utils/notification';

const mapApiToForm = dados => {
  const mappedData = {
    nome: dados.Nome || '',
    cnpj: dados.Cnpj || '',
    codigoIntegracao: dados.CodigoIntegracao || '',
    telefone: dados.Telefone || '',
    observacoes: dados.Observacao || '',
    dataCriacao: dados.DataCriacao ? new Date(dados.DataCriacao) : null,
    dataModificacao: dados.DataModificacao ? new Date(dados.DataModificacao) : null,
    email: dados.Email || ''
  };
  return mappedData;
};

const mapFormToUpdateApi = values => {
  return {
    Nome: values.nome,
    Cnpj: values.cnpj,
    CodigoIntegracao: values.codigoIntegracao,
    Telefone: values.telefone,
    Observacao: values.observacoes || '',
    Email: values.email
  };
};

export const useClienteDetalhes = () => {
  const {
    id
  } = useParams();
  const history = useHistory();
  const [dadosRecebidos, setDadosRecebidos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const isMountedRef = useRef(true); // Cleanup quando componente é desmontado

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []); // Carregar dados do cliente

  useEffect(() => {
    if (!id || !isMountedRef.current) return;

    const loadCliente = async () => {
      try {
        const data = await getCliente(id);

        if (isMountedRef.current) {
          setDadosRecebidos(data);
        }
      } catch (error) {
        if (isMountedRef.current) {
          notification.error('Erro ao carregar dados do cliente.');
        }
      } finally {
        if (isMountedRef.current) {
          setLoading(false);
        }
      }
    };

    loadCliente();
  }, [id]); // Atualizar cliente

  const handleSubmit = useCallback(async values => {
    try {
      setSaving(true);
      const payload = mapFormToUpdateApi(values);
      await updateCliente(id, payload);

      if (isMountedRef.current) {
        notification.success('Cliente atualizado com sucesso!');
        history.goBack();
      }
    } catch (error) {
      if (isMountedRef.current) {
        notification.error(`Erro ao atualizar: ${error.message}`);
      }
    } finally {
      if (isMountedRef.current) {
        setSaving(false);
      }
    }
  }, [id, history]); // Deletar cliente

  const handleDelete = useCallback(async () => {
    try {
      setDeleting(true);
      await deleteCliente(id);

      if (isMountedRef.current) {
        notification.success('Cliente excluído com sucesso!');
        history.goBack();
      }
    } catch (err) {
      if (isMountedRef.current) {
        notification.error(`Erro ao deletar: ${err.message}`);
      }
    } finally {
      if (isMountedRef.current) {
        setDeleting(false);
        setModalVisible(false);
      }
    }
  }, [id, history]); // Navegar para edição

  const handleEditar = useCallback(() => {
    history.push(`/pages/clientes/editar/${id}`);
  }, [history, id]); // Voltar para listagem

  const handleVoltar = useCallback(() => {
    history.push('/pages/clientes');
  }, [history]); // Mapear dados para formulário

  const initialValues = dadosRecebidos ? mapApiToForm(dadosRecebidos) : {};
  return {
    // Estados
    dadosRecebidos,
    loading,
    saving,
    deleting,
    modalVisible,
    initialValues,
    // Handlers
    handleSubmit,
    handleDelete,
    handleEditar,
    handleVoltar,
    setModalVisible,
    // Utilitários
    mapApiToForm,
    mapFormToUpdateApi
  };
};
